import { ErrorHelper } from '@/helpers/ErrorHelper'
import { mapState, mapActions, mapMutations } from 'vuex'
import { SelectedSiteIdMixin } from './SelectedSiteIdMixin'

export const ClientSetMixin = {
  mixins: [SelectedSiteIdMixin],
  data () {
    return {
      error: ''
    }
  },
  computed: {
    ...mapState('Client', [
      'loadedClient',
      'loadingClient',
      'attempted',
      'client'
    ]),
    attemptedClient () {
      return !!this.attempted
    }
  },
  watch: {
    selectedSiteId () {
      this.refreshClient()
    },
    client (value) {
      if (!value) return
      this.setClientId(value.id || '')
      this.setClientTypeId(1)
      this.setFirstName(value.firstName || '')
      this.setLastName(value.lastName || '')
      this.setEmail(value.email || '')
      this.setTelephoneMobile(value.telephoneMobile || '')
    }
  },
  methods: {
    ...mapActions('Client', [
      'fetchClientBySiteId'
    ]),
    ...mapMutations('BookingUpload', [
      'setClientId',
      'setClientTypeId',
      'setFirstName',
      'setLastName',
      'setEmail',
      'setTelephoneMobile'
    ]),
    refreshClient () {
      if (!this.loadedClient && !this.loadingClient) {
        this.tryFetchClientBySiteId()
      }
    },
    tryFetchClientBySiteId () {
      if (!this.selectedSiteId) return

      this.error = ''
      this.fetchClientBySiteId(this.selectedSiteId)
        .then(response => this.afterFetchClient(response.data))
        .catch(error => {
          this.error = ErrorHelper.getError(error)
        })
    },
    afterFetchClient () {
      // override if necessary
    }
  },
  created () {
    this.refreshClient()
  }
}
